import React from 'react'
import HeroImg from '../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../components/Constant/button/Button";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import CTA from "../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Indonesia Company Formation',
        link: '/indonesia-company-formation',
    },
]

function IndonesiaCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Indonesia Company Formation (PT PMA)</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Establish Your Business in Southeast Asia’s Fastest-Growing Market</h3>

                            <p className='page-paragraph'>
                                <b>A PT PMA</b> is the official foreign-owned company structure in Indonesia, allowing non-Indonesians to engage in commercial activities, employ staff, and access <b> residency permits (Investor KITAS).</b>
                                <br/>
                                It is the gateway for entrepreneurs looking to build businesses in <b> Bali, Jakarta, and beyond,</b> covering industries such as tourism, consulting, e-commerce, import/export, and fintech.
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "100% Foreign Ownership (in eligible sectors)",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Legal Entity",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Residency Rights",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Market Access",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request an Indonesia Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Incorporate in Indonesia?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Huge Market",
                                    paragraph: "270M+ population, fastest-growing middle class in Asia",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Legal Ownership",
                                    paragraph: "PMA is the only way foreigners can fully own companies",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Residency Link",
                                    paragraph: "Investors can apply for Investor KITAS",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tourism & Digital Hub",
                                    paragraph: "Bali & Jakarta are hotspots for startups",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Gateway to ASEAN",
                                    paragraph: "Access to regional trade networks",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Key Features of PT PMA
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Recognized as a legal Indonesian entity",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Minimum 1 director, 1 commissioner, and 2 shareholders",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Foreign ownership allowed",
                                    paragraph: "Subject to Negative Investment List restrictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Eligible to sponsor Investor KITAS",
                                    paragraph: "Residency visa for investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Minimum paid-up capital",
                                    paragraph: "IDR 10 billion (~USD 650,000) (varies by sector)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local registered office required",
                                    paragraph: "Must be located in Indonesia",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of PT PMA</h3>
                        <PageList
                            items={[
                                {
                                    title: "Full Legal Standing",
                                    paragraph: "Operate as a legitimate company in Indonesia",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Residency & Work Permits",
                                    paragraph: "Owner can secure Investor KITAS",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Access",
                                    paragraph: "Open local corporate bank accounts",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Wide Scope",
                                    paragraph: "Import/export, tourism, fintech, consulting, and more",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Attract Investment",
                                    paragraph: "Local and foreign investors trust PT PMAs",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Minimum 2 shareholders",
                                    paragraph: "Can be foreign individuals or companies",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "1 director",
                                    paragraph: "Can be foreign, but often locals required for certain activities",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "1 commissioner",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local office lease agreement",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Paid-up capital requirements",
                                    paragraph: "Vary by industry",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Submission of KYC documents",
                                    paragraph: "Required for all shareholders",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Sector Selection",
                                    paragraph: "Confirm if sector is open to foreign ownership",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Check and reserve company name",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Deed of Establishment",
                                    paragraph: "Drafted & notarized",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Registration",
                                    paragraph: "Through the Ministry of Law & Human Rights",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Business License (NIB)",
                                    paragraph: "Issued via OSS system",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax ID & Bank Account Opening",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor KITAS Application",
                                    paragraph: "If required",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "6–8 weeks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 4,000+ depending on sector",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Accounting, reporting, nominee (if needed), KITAS renewals",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Common Uses of PT PMA
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "Hospitality & Tourism (Bali hotels, restaurants, travel companies)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "E-commerce & Tech Startups (Jakarta & Bali hubs)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Import/Export & Trading",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Consulting & Services",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "FinTech & Digital Platforms",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Experts in foreign company setups in Indonesia",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Assistance with Investor KITAS residency permits",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong network in Bali & Jakarta",
                                    paragraph: "For legal, tax, and staffing support",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Indonesia vs Singapore vs Malaysia vs UAE",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-end support",
                                    paragraph: "Incorporation, licensing, compliance, and banking",
                                    icon: GoDotFill,
                                },
                            ]}
                        />



                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking to establish your business in Bali, Jakarta, or across Indonesia?"
                        description="A <b>PT PMA</b> provides full legal standing, market access, and residency rights for foreign entrepreneurs."
                        buttonText="Book an Indonesia Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default IndonesiaCompanyFormation;

const faqData = [
{
    question: "Can foreigners own 100% of a company in Indonesia?",
        content: [
        { type: "answer", text: "Yes — in many sectors, but some are restricted under the Negative Investment List." },
    ],
},
{
    question: "What is the capital requirement for a PT PMA?",
        content: [
        { type: "answer", text: "Typically IDR 10 billion (~USD 650,000), but can vary by industry." },
    ],
},
{
    question: "Can I live in Indonesia with a PT PMA?",
        content: [
        { type: "answer", text: "Yes — owners can apply for an Investor KITAS residency visa." },
    ],
},
{
    question: "How long does incorporation take?",
        content: [
        { type: "answer", text: "6–8 weeks depending on approvals." },
    ],
},
{
    question: "Can a PT PMA sponsor employees?",
        content: [
        { type: "answer", text: "Yes — it can issue work permits (KITAS) for foreign staff." },
    ],
},
];

const testimonialsData = [
    {
        quote:
            "We established our Bali hospitality company as a PT PMA. Offshore Advisory managed incorporation and our KITAS permits.",
        author: "Marco P.",
        role: "Hotel Investor",
    },
    {
        quote:
            "As a digital nomad, forming a PT PMA gave me residency and a legal business base. Offshore Advisory handled everything smoothly.",
        author: "Aisha T.",
        role: "Tech Entrepreneur",
    },
];